import {inlineError} from '@s-ui/decorators/lib'
import {Service} from '@s-ui/domain'

/**
 * @implements Service
 */
export class GetPhoneVerificationCodeUserService extends Service {
  /**
   * @constructor
   * @param {Object} deps
   * @param {ErrorFactory} deps.userNotLoggedInUserErrorFactory
   * @param {Repository} deps.userRepository
   */
  constructor({userNotLoggedInUserErrorFactory, userRepository}) {
    super()

    this._userNotLoggedInUserErrorFactory = userNotLoggedInUserErrorFactory
    this._userRepository = userRepository
  }

  @inlineError
  async execute({userEntity}) {
    if (!userEntity)
      return Promise.reject(
        this._userNotLoggedInUserErrorFactory({
          message: 'To get phone verification code the user must be logged in'
        }).toJSON()
      )

    const [error] = await this._userRepository.getPhoneVerificationCode({
      userEntity
    })

    return error ? Promise.reject(JSON.parse(error.message)) : Promise.resolve()
  }
}
